import { Button, CircularProgress, Grid2, InputAdornment, TextField, Typography } from "@mui/material";
import { useMemo, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import api from "../../../utils/axios";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { enqueueSnackbar } from "notistack";
import { IService } from "sierra";
import { useApp } from "../../../contexts/AppContext";

const ResetPassword = ({ reset_token }: { reset_token: string }) => {
    const navigate = useNavigate()
    const location = useLocation()
    const {translate} = useApp()

    const service: IService = useMemo(() => location.state?.service, [location])

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPass, setShowPass] = useState(false)
    const [submitting, setSubmitting] = useState(false)
    const [resetted, setResetted] = useState(false)

    const handleSubmit = () => {
        if (password !== confirmPassword) return enqueueSnackbar('Password must match', { variant: 'error' })
        setSubmitting(true)
        api.post('/auth/forgotPassword/reset', { reset_token, new_password: password }).then(() => setResetted(true)).catch(console.error).finally(() => setSubmitting(false))
    }

    return (
        resetted ?
            <Grid2 container flexDirection={'column'} alignItems={'center'} gap={2}>
                <Grid2>
                    <Typography variant="h5" fontWeight={'bold'}>{translate("Your password has been reset!")}</Typography>
                </Grid2>
                <Grid2>
                    <Button onClick={() => navigate('/login', !service ? undefined : { state: { service: service } })}>{translate("Go back to login")}</Button>
                </Grid2>
            </Grid2> :
            <Grid2 container flexDirection={'column'} gap={7}>
                <Grid2>
                    <Typography variant="h5" fontWeight={'bold'}>Reset Your Password</Typography>
                </Grid2>
                <Grid2 container flexDirection={'column'} gap={3}>
                    <Grid2 container flexDirection={'column'} gap={2}>
                        <Grid2>
                            <TextField required autoComplete="new-password" label={translate('New Password')} size='small' type={showPass ? "text" : "password"} fullWidth onChange={(e) => setPassword(e.target.value)} value={password}
                                slotProps={{
                                    input: {
                                        endAdornment: (
                                            <InputAdornment position="start" onClick={() => setShowPass(v => !v)} sx={{ cursor: 'pointer' }}>
                                                {showPass ? <VisibilityOff /> : <Visibility />}
                                            </InputAdornment>
                                        ),
                                    },
                                }} />
                        </Grid2>
                        <Grid2>
                            <TextField required label={translate('Confirm Password')} size='small' type={showPass ? "text" : "password"} fullWidth onChange={(e) => setConfirmPassword(e.target.value)} value={confirmPassword}
                                slotProps={{
                                    input: {
                                        endAdornment: (
                                            <InputAdornment position="start" onClick={() => setShowPass(v => !v)} sx={{ cursor: 'pointer' }}>
                                                {showPass ? <VisibilityOff /> : <Visibility />}
                                            </InputAdornment>
                                        ),
                                    },
                                }} />
                        </Grid2>
                    </Grid2>
                    <Grid2>
                        <Button onClick={handleSubmit} disabled={!password || !confirmPassword || submitting} startIcon={submitting && <CircularProgress />} variant="contained" fullWidth>{translate("Reset Password")}</Button>
                    </Grid2>
                </Grid2>
            </Grid2>
    )
}

const RequestLink = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const {translate} = useApp()

    const service: IService = useMemo(() => location.state?.service, [location])

    const [email, setEmail] = useState('');
    const [submitting, setSubmitting] = useState(false)
    const [requested, setRequested] = useState(false)

    const handleSubmit = () => {
        setSubmitting(true)
        api.post('/auth/forgotPassword/requestLink', { email }).then(() => setRequested(true)).catch(console.error).finally(() => setSubmitting(false))
    }

    return (
        requested ?
            <Grid2 container flexDirection={'column'} alignItems={'center'} gap={2}>
                <Grid2>
                    <Typography variant="h5" fontWeight={'bold'}>{translate("Password reset link has been submitted on your email!")}</Typography>
                </Grid2>
                <Grid2>
                    <Button onClick={() => navigate('/login', !service ? undefined : { state: { service: service } })}>{translate("Go back to login")}</Button>
                </Grid2>
            </Grid2> :
            <Grid2 container flexDirection={'column'} gap={7}>
                <Grid2>
                    <Typography variant="h5" fontWeight={'bold'}>{translate("Request a Password Reset Link")}</Typography>
                </Grid2>
                <Grid2 container flexDirection={'column'} gap={3}>
                    <Grid2>
                        <TextField required autoComplete="username" name="email" onKeyUp={(e) => e.key === 'Enter' && handleSubmit()} label={translate('Email')} size="small" fullWidth onChange={(e) => setEmail(e.target.value)} value={email} />
                    </Grid2>
                    <Grid2>
                        <Button onClick={handleSubmit} disabled={!email || submitting} startIcon={submitting && <CircularProgress />} variant="contained" fullWidth>{translate("REQUEST LINK")}</Button>
                    </Grid2>
                </Grid2>
            </Grid2>
    )
}

export default function ForgotPassword() {
    const [searchParams] = useSearchParams()

    const reset_token = searchParams.get('resetToken')

    return (
        <Grid2 container height={'100vh'} flexDirection={{ xs: 'column', md: 'row' }}>
            <Grid2 container size={'grow'} flexDirection={'column'} alignItems={'center'} justifyContent={'center'}>
                <Grid2 container flexDirection={'column'} minWidth={{ lg: 500, xs: 'auto' }}>
                    {reset_token ? <ResetPassword reset_token={reset_token} /> :
                        <RequestLink />}
                </Grid2>
            </Grid2>
            <Grid2 size={'grow'} sx={{ backgroundColor: (t) => t.palette.primary.main }} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                <img src="/sierra-logo.png" />
            </Grid2>
        </Grid2>
    )
}